import axios from 'axios';
import { loginreq, req } from './axiosFun';

// 定义通用api前缀
//其知网后台接口url前缀(本地)
// var webRoot = 'http://192.168.101.7/index.php';
//其知网后台后台接口url前缀(线上)
var webRoot = 'https://zlbb.qzhip.com/index.php';
// var webRoot = 'http://zlbb.qzhip.test/index.php';


// 控制台
// 获取统计数据
export const consolePanel = (params) => { return req("post", "/patent/console/getConsolePanel", params) };
// 获取统计数据（园区版）
export const getConsolePanelPark = (params) => { return req("post", "/patent/console/getConsolePanelPark", params) };
// 获取统计数据（代理机构版）
export const consoleAgency = (params) => { return req("post", "/patent/console/getConsoleAgency", params) };

// 个人中心-获取个人信息
export const getAdminInfo = (params) => { return req("post", "/patent/admin/getAdminInfo", params) };


export const webUrl = 'https://zlbb.qzhip.com/index.php';
// export const webUrl = 'http://zlbb.qzhip.test/index.php';


// WEBPACK FOOTER //
// ./src/api/consoleMG.js